<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card>
      <div class="text-right add-leave common-header" v-if="!leaveAddEdit">
        <div class="vx-card__header pt-0 pl-0">
          <div class="vx-card__title">
            <h4>Manage leaves</h4>
          </div>
        </div>
        <div>
          <vs-button
            v-if="
              this.$store.state.uInfo.role === 'HR' ||
              this.$store.state.uInfo.role === 'CA'
            "
            class="mt-4 mb-5 m-auto gradient-btn"
            @click.prevent="leaveAddEdit = true"
            >Request Leave</vs-button
          >
        </div>
      </div>
      <form class="w-full" data-vv-scope="leave-form" v-if="leaveAddEdit" :autocomplete="'off'">
        <div class="vx-row mb-2">
          <h4 class="ml-5 mb-5">Add Leave</h4>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-radio
              v-model="is_applied_by_other"
              vs-name="is_applied_by_other"
              name="is_applied_by_other"
              v-validate="'required'"
              :vs-value="false"
              >Personal Leave</vs-radio
            >
            <vs-radio
              v-model="is_applied_by_other"
              vs-name="is_applied_by_other"
              v-validate="'required'"
              name="is_applied_by_other"
              :vs-value="true"
              >Staff Leave</vs-radio
            >

            <span class="text-danger text-sm">
              {{ errors.first("leave-form.is_applied_by_other") }}
            </span>
          </div>
        </div>
        <div class="vx-row w-full mb-2">
          <div
            class="vx-col md:w-1/4 form-group w-full pr-1"
            v-show="is_applied_by_other"
          >
            <vs-select
              
              class="w-full"
              label="Office"
              name="office_id_hr"
              v-model="office_id_hr"
              v-validate="is_applied_by_other == true ? 'required' : ''"
              @change="changeOffice()"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.office_name"
                v-for="(item, index) in offices"
              />
            </vs-select>
            <span class="text-danger text-sm">
              {{ errors.first("leave-form.office_id_hr") }}
            </span>
          </div>
          <div
            class="vx-col md:w-1/4 form-group w-full pr-1"
            v-show="is_applied_by_other"
          >
            <vs-select
              
              class="w-full"
              label="Department"
              name="department_id"
              v-model="department_id"
              @change="changeDept()"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.department_name"
                v-for="(item, index) in departments"
              />
            </vs-select>
            <span class="text-danger text-sm">
              {{ errors.first("leave-form.department_id") }}
            </span>
          </div>
        </div>
        <div class="vx-row w-full">
          <div
            class="vx-col md:w-1/4 form-group w-full pr-1"
            v-show="is_applied_by_other"
          >
            <vs-select
              @change="changeUser()"
              class="w-full"
              v-validate="is_applied_by_other == true ? 'required' : ''"
              label="User"
              name="user_id"
              v-model="user_id"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.firstname + ' ' + item.lastname"
                v-for="(item, index) in users"
              />
            </vs-select>
            <span class="text-danger text-sm">
              {{ errors.first("leave-form.user_id") }}
            </span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full pr-1">
            <vs-select
              class="w-full"
              v-validate="'required'"
              label="Leave Type"
              name="type"
              v-model="type"
              
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.value"
                v-for="(item, index) in leavetypes"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first("leave-form.type") }}</span>
          </div>
        </div>
        <div class="vx-row w-full mb-2 mt-2">
          <div class="vx-col form-group md:w-1/4 w-full pr-1">
            <label for class="vs-input--label">Description</label>
            <vs-textarea v-model="note" v-validate="'max:200'" name="note" />
            <span class="text-danger text-sm">{{ errors.first("leave-form.note") }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col form-group w-full">
            <h4>Start Day Details</h4>
            <div class="vx-row">
              <div class="vx-col md:w-1/4 form-group w-full">
                <label for class="vs-input--label">Start Date</label>
                <flat-pickr
                  :config="configFromdateTimePicker"
                  @on-change="onFromChange"
                  class="vs-inputx vs-input--input normal time"
                  label="Start Date"
                  v-validate="'required'"
                  name="start_date"
                  v-model="start_date"
                />
                <span class="text-danger text-sm">
                  {{ errors.first("leave-form.start_date") }}
                </span>
              </div>
              <div class="vx-col md:w-1/4 form-group w-full">
                <label for class="vs-input--label">Start Day</label>
                <vs-radio
                  v-model="start_day_option"
                  v-validate="'required'"
                  vs-value="F"
                  >Full Day</vs-radio
                >
                <vs-radio
                  v-model="start_day_option"
                  v-validate="'required'"
                  vs-value="H"
                  >Partial Day</vs-radio
                >

                <span class="text-danger text-sm">
                  {{ errors.first("leave-form.start_day_option") }}
                </span>
              </div>
              <div
                class="vx-col md:w-1/4 form-group w-full"
                v-if="start_day_option == 'H'"
              >
                <label for class="vs-input--label">Start Time</label>
                <flat-pickr
                  :config="configdateTimePicker"
                  class="vs-inputx vs-input--input normal time"
                  v-validate="start_day_option == 'H' ? 'required' : ''"
                  v-model="start_time"
                  name="start_time"
                   @input="calculateDays"
                />
                <span class="text-danger text-sm">
                  {{ errors.first("leave-form.start_time") }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col form-group w-full">
            <h4>End Day Details</h4>
            <div class="vx-row">
              <div class="vx-col md:w-1/4 form-group w-full">
                <label for class="vs-input--label">End Date</label>
                <flat-pickr
                  :config="configTodateTimePicker"
                  class="vs-inputx vs-input--input normal time"
                  label="End Date"
                  v-validate="'required'"
                  name="end_date"
                  v-model="end_date"
              
                  @input="calculateDays"
           
                />
                <span class="text-danger text-sm">
                  {{ errors.first("leave-form.end_date") }}
                </span>
              </div>
              <div class="vx-col md:w-1/4 form-group w-full">
                <label for class="vs-input--label">End Day</label>
                <vs-radio
                  v-model="end_day_option"
                  vs-name="end_day_option"
                  vs-value="Full"
                  name="end_day_option"
                  v-validate="'required'"

                  >Full Day</vs-radio
                >
                <vs-radio
                  v-model="end_day_option"
                  vs-name="end_day_option"
                  vs-value="Half"
                  name="end_day_option"
                  v-validate="'required'"

                  >Partial Day</vs-radio
                >

                <span class="text-danger text-sm">
                  {{ errors.first("leave-form.end_day_option") }}
                </span>
              </div>
              <div
                class="vx-col md:w-1/4 form-group w-full"
                v-if="end_day_option == 'Half'"
              >
                <label for class="vs-input--label">End Time</label>
                <flat-pickr
                  :config="configdateTimePicker"
                  class="vs-inputx vs-input--input normal time"
                  v-validate="'required'"
                  v-model="end_time"
                  autocomplete="off"
                  name="end_time"
                   @input="calculateDays"
                />
                <span class="text-danger text-sm">
                  {{ errors.first("leave-form.end_time") }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mb-2" v-if="is_applied_by_other">
          <div class="vx-col w-full">
            <vs-checkbox v-model="approveleave" :vs-value="true"
              >Approve Leave</vs-checkbox
            >
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-1/3 mt-2" v-if="start_date && end_date">
            <label>Total day/s</label>
            <vs-input name="days" v-model="totalDays" class="w-1/2" disabled />
          </div>
          <div class="vx-col w-1/4">
            <div class="vx-row mb-2">
              <div class="vx-col w-full flex">
                <vs-button
                  class="mt-1 m-auto gradient-btn"
                  @click.prevent="addLeave()"
                  :disabled="button_loading"
                  id="leavetype-addupdate"
                  >Apply</vs-button
                >
                <vs-button
                  class="mt-1 ml-4 m-auto gradient-btn"
                  @click.prevent="cancelAdd()"
                  >Cancel</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </form>
      <form>
        <div
          class="md:w-auto md:mt-0 sm:w-full w-full sm:mt-3 mt-3 search-header"
        >
          <div class="inline-block mr-2 lg-15 w-auto mb-2 z-999">
            <vs-input
              name="search"
              placeholder="Search"
              class="w-full no-icon-border"
              v-model="search"
              autocomplete="off"
              @keyup="getLeaveData()"
            />
          </div>
          <div class="inline-block mr-2 lg-15 w-auto mb-2 z-999">
            <vs-select
              class="w-full"
              v-validate="'required'"
              name="sort"
              placeholder="All Offices"
              v-model="office"
              @input="getLeaveData(),getDept()"
            >
               <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.office_name"
                v-for="(item,index) in officesAll"
              />
            </vs-select>
          </div>
          <div class="inline-block mr-0 lg-15 w-auto mb-2 z-999">
            <vs-select
              class="w-full"
              v-validate="'required'"
              name="sort"
              placeholder="All Deparments"
              v-model="department"
              @input="getLeaveData()"
            >
                <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.department_name"
                v-for="(item,index) in departments"
              />
            </vs-select>
          </div>
        </div>
      </form>
      <!-- <div class="vx-row mb-2 justify-content-end">
          <div class="vx-col w-1/6 mt-2">
            <vs-input name="days" v-model="totalDays" class="input-width-100" />
          </div>
          <div class="vx-col w-1/6 mt-2">
            <vs-input name="days" v-model="totalDays" class="input-width-100" />
          </div>
          <div class="vx-col w-1/6 mt-2">
            <vs-input name="days" v-model="totalDays" class="input-width-100" />
          </div>
        </div> -->
      <vs-tabs v-if="!leaveAddEdit" class="top-50-tab border-tabs-set">
        <vs-tab label="Pending">
          <div class="tab-text">
            <div class="mt-10 mb-5">
              <vs-table
                :data="pending"
                pagination
                max-items="5"
                class="mt-10 mb-5"
              >
                <template slot="thead">
                  <vs-th>Name</vs-th>
                  <vs-th>Leave Type</vs-th>
                  <vs-th sort-key="start_time">Start</vs-th>
                  <vs-th>End</vs-th>
                  <vs-th width="70px">Total</vs-th>
                  <vs-th>Note</vs-th>
                  <vs-th></vs-th>
                  <vs-th>Status</vs-th>
                  <vs-th>Action</vs-th>
                  <vs-th sort-key="createdAt">Applied On</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                    <vs-td>
                      <div
                        class="relative flex float-left leave-img justify-center"
                      >
                        <img
                          :src="tr.user_id.profile_image"
                          width="50px"
                          height="50px"
                          v-if="tr.user_id.profile_image"
                        />
                        <vs-avatar
                          color="primary"
                          class="m-0 name-avatar"
                          :text="
                            usernameList(
                              tr.user_id.firstname,
                              tr.user_id.lastname
                            )
                          "
                          size="50px"
                          v-else
                        />
                        <div class="ml-2 m-auto name">
                          <b>
                            {{ tr.user_id.firstname | capitalize }}
                            {{ tr.user_id.lastname | capitalize }}
                          </b>
                        </div>
                      </div>
                    </vs-td>
                    <vs-td>{{ tr.type.value | capitalize }}</vs-td>
                    <vs-td>
                      <span>
                        {{
                          tr.start_time
                            | moment(
                              "timezone",
                              $store.state.uInfo.timeZone,
                              "DD/MM/YY"
                            )
                        }}
                      </span>
                      <span
                        v-if="tr.start_day_option === 'H'"
                        class="text-sm dis-block"
                      >
                        {{ tr.start_day_time }}
                      </span>
                    </vs-td>
                    <vs-td>
                      <span>
                        {{
                          tr.end_time
                            | moment(
                              "timezone",
                              $store.state.uInfo.timeZone,
                              "DD/MM/YY"
                            )
                        }}
                      </span>
                      <span
                        v-if="tr.start_day_option === 'H'"
                        class="text-sm dis-block"
                      >
                        {{ tr.end_day_time }}
                      </span>
                    </vs-td>
                    <vs-td width="70px">
                      <!-- <span
                        class="text-sm">
                      {{ tr.start_day_option}} to {{ tr.end_day_option}} 
                        </span>
                      <span
                        class="text-sm"
                        v-if="tr.start_day_option === 'H'"
                        >
                        {{ tr.start_day_time}} to {{ tr.end_day_time}} 
                        </span>
                      <span
                        class="text-sm"
                        v-if="tr.totalDays != 0 && tr.start_day_option === 'F'"
                        >{{ tr.totalDays }}</span
                      >
                      <span
                        class="text-sm"
                        v-if="tr.totalDays != 0 && tr.start_day_option === 'F'"
                        >{{ tr.totalDays > 1 ? " days" : " day" }}</span
                      > -->
                      <span v-if="tr.start_day_option === 'F' && tr.end_day_option === 'F' && tr.totalDays">{{ tr.totalDays > 1 ? tr.totalDays+" days" : tr.totalDays+" day" }}</span>
                       <span v-if="(tr.start_day_option === 'F' && tr.end_day_option === 'H') || (tr.start_day_option === 'H' && tr.end_day_option === 'F')">{{ tr.totalDays }} {{ tr.totalDays > 1 ?" days " :" day "}}
                       {{  convertToTime(tr.totalMinutes) }}
                       </span>
                      <span v-if="tr.start_day_option === 'H' && tr.end_day_option === 'H' && tr.totalDays == 0">{{ convertToTime(tr.totalMinutes) }}</span>
                      <span v-if="tr.start_day_option === 'H' && tr.end_day_option === 'H' && tr.totalDays != 0">{{ tr.totalDays}}{{ tr.totalDays > 1 ?" days " :" day "  }}{{  convertToTime(tr.totalMinutes) }}</span>
                    </vs-td>
                    <vs-td>
                      <p>
                        <label
                          class="day-label"
                          v-if="tr.start_day_option === 'H' && tr.end_day_option === 'H'&& tr.totalDays == 0"
                          >Partial Day:</label
                        >
                        <span
                          :class="tr.start_day_option === 'H ' ? 'text-sm' : ''"
                          >{{ tr.note | readMore }}</span
                        >
                      </p>
                    </vs-td>
                    <vs-td>
                      <feather-icon
                        v-if="tr.note"
                        icon="PlusIcon"
                        class="mr-0 cursor-pointer plus-btn"
                        svg-classes="stroke-current"
                        @click.stop="
                          viewNote(
                            tr.note,
                            tr._id,
                            tr.user_id.firstname,
                            tr.user_id.lastname
                          )
                        "
                      ></feather-icon>
                    </vs-td>
                    <vs-td class="text-warning">{{
                      tr.status == "P" ? "Pending" : ""
                    }}</vs-td>
                    <vs-td v-if="tr.user_id._id == $store.state.uInfo.id">
                      <vs-button
                        color="danger"
                        type="filled"
                        class="mr-2 mb-2 edit-user float-left"
                        size="small"
                        title="Cancel Leave"
                        @click.stop="cancelConfirmation(tr._id)"
                        >Cancel</vs-button
                      >
                    </vs-td>
                    <vs-td v-else>
                      <vs-button
                        color="success"
                        type="filled"
                        class="mr-2 mb-2 edit-user float-left"
                        size="small"
                        title="Approve Leave"
                        @click.stop="confirmApproveLeave(tr._id)"
                        >Approve</vs-button
                      >
                      <vs-button
                        color="danger"
                        type="filled"
                        class="mr-2 mb-2 edit-user float-left"
                        size="small"
                        title="Decline Leave"
                        @click.stop="decline(tr._id)"
                        >Decline</vs-button
                      >
                    </vs-td>
                    <vs-td>
                      <span>
                        {{
                          tr.createdAt
                            | moment(
                              "timezone",
                              $store.state.uInfo.timeZone,
                              "DD/MM/YY"
                            )
                        }}
                      </span>
                      <span class="text-sm">
                        {{
                          tr.createdAt
                            | moment(
                              "timezone",
                              $store.state.uInfo.timeZone,
                              " h:mm A"
                            )
                        }}
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Approved">
          <div class="tab-text">
            <div class="mt-10 mb-5">
              <vs-table
                :data="approved"
                pagination
                max-items="5"
                class="mt-10 mb-5 approved-table"
              >
                <template slot="thead">
                  <vs-th>Name</vs-th>
                  <vs-th>Leave Type</vs-th>
                  <vs-th sort-key="start_time">Start</vs-th>
                  <vs-th>End</vs-th>
                  <vs-th width="70px">Total</vs-th>
                  <vs-th>Note</vs-th>
                  <vs-th></vs-th>
                  <vs-th>Status</vs-th>
                  <vs-th>Action</vs-th>
                  <vs-th sort-key="createdAt">Applied On</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <div
                        class="relative flex float-left leave-img justify-center"
                      >
                        <img
                          :src="tr.user_id.profile_image"
                          height="50px"
                          width="50px"
                          v-if="tr.user_id.profile_image"
                        />
                        <vs-avatar
                          color="primary"
                          class="m-0 name-avatar"
                          :text="
                            usernameList(
                              tr.user_id.firstname,
                              tr.user_id.lastname
                            )
                          "
                          size="50px"
                          v-else
                        />
                        <div class="ml-2 mt-3">
                          <b>
                            {{ tr.user_id.firstname | capitalize }}
                            {{ tr.user_id.lastname | capitalize }}
                          </b>
                        </div>
                      </div>
                    </vs-td>
                    <vs-td>{{ tr.type.value | capitalize }}</vs-td>

                    <vs-td>
                      <span>
                        {{
                          tr.start_time
                            | moment(
                              "timezone",
                              $store.state.uInfo.timeZone,
                              "DD/MM/YY"
                            )
                        }}
                      </span>
                      <span v-if="tr.start_day_option === 'H'" class="text-sm">
                        {{ tr.start_day_time }}
                      </span>
                    </vs-td>
                    <vs-td>
                      <span>
                        {{
                          tr.end_time
                            | moment(
                              "timezone",
                              $store.state.uInfo.timeZone,
                              "DD/MM/YY"
                            )
                        }}
                      </span>
                      <span v-if="tr.start_day_option === 'H'" class="text-sm">
                        {{ tr.end_day_time }}
                      </span>
                    </vs-td>
                    <vs-td width="70px">
                        <span v-if="tr.start_day_option === 'F' && tr.end_day_option === 'F' && tr.totalDays">{{ tr.totalDays > 1 ? tr.totalDays+" days" : tr.totalDays+" day" }}</span>
                       <span v-if="(tr.start_day_option === 'F' && tr.end_day_option === 'H') || (tr.start_day_option === 'H' && tr.end_day_option === 'F')">{{ tr.totalDays }} {{ tr.totalDays > 1 ?" days " :" day "}}
                       {{  convertToTime(tr.totalMinutes) }}
                       </span>
                      <span v-if="tr.start_day_option === 'H' && tr.end_day_option === 'H' && tr.totalDays == 0">{{ convertToTime(tr.totalMinutes) }}</span>
                      <span v-if="tr.start_day_option === 'H' && tr.end_day_option === 'H' && tr.totalDays != 0">{{ tr.totalDays}}{{ tr.totalDays > 1 ?" days " :" day "  }}{{  convertToTime(tr.totalMinutes) }}</span>
                    </vs-td>
                    <vs-td>
                      <p>
                        <label
                          class="day-label"
                          v-if="tr.start_day_option === 'H'"
                          >Partial Day:</label
                        >
                        <span
                          :class="tr.start_day_option === 'H' ? 'text-sm' : ''"
                          >{{ tr.note | readMore }}</span
                        >
                      </p>
                    </vs-td>
                    <vs-td>
                      <feather-icon
                        v-if="tr.note"
                        icon="PlusIcon"
                        class="mr-0 cursor-pointer plus-btn"
                        svg-classes="stroke-current"
                        @click.stop="
                          viewNote(
                            tr.note,
                            tr._id,
                            tr.user_id.firstname,
                            tr.user_id.lastname
                          )
                        "
                      ></feather-icon>
                    </vs-td>
                    <vs-td class="text-success">{{
                      tr.status == "A" ? "Approved" : ""
                    }}</vs-td>
                    <vs-td v-if="tr.user_id._id == $store.state.uInfo.id">
                      <vs-button
                        color="danger"
                        type="filled"
                        class="mr-2 mb-2 edit-user float-left"
                        size="small"
                        title="Cancel Leave"
                        @click.stop="cancelConfirmation(tr._id)"
                        >Cancel</vs-button
                      >
                    </vs-td>
                    <vs-td v-else>
                      <vs-button
                        color="danger"
                        type="filled"
                        class="mr-2 mb-2 edit-user float-left"
                        size="small"
                        title="Decline Leave"
                        @click.stop="decline(tr._id)"
                        >Decline</vs-button
                      >
                    </vs-td>
                    <vs-td>
                      <span>
                        {{
                          tr.createdAt
                            | moment(
                              "timezone",
                              $store.state.uInfo.timeZone,
                              "DD/MM/YY"
                            )
                        }}
                      </span>
                      <span class="text-sm">
                        {{
                          tr.createdAt
                            | moment(
                              "timezone",
                              $store.state.uInfo.timeZone,
                              "h:mm A"
                            )
                        }}
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Declined">
          <div class="tab-text">
            <div class="mt-10 mb-5">
              <vs-table
                :data="declined"
                pagination
                max-items="5"
                class="mt-10 mb-5"
              >
                <template slot="thead">
                  <vs-th>Name</vs-th>
                  <vs-th>Leave Type</vs-th>
                  <vs-th sort-key="start_time">Start</vs-th>
                  <vs-th>End</vs-th>
                  <vs-th>Total</vs-th>
                  <!-- <vs-th>Note</vs-th> -->
                  <vs-th></vs-th>
                  <vs-th>Comment</vs-th>
                  <vs-th>Status</vs-th>
                  <vs-th sort-key="createdAt">Declined On</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <div
                        class="relative flex float-left leave-img justify-center"
                      >
                        <img
                          :src="tr.user_id.profile_image"
                          width="50px"
                          height="50px"
                          v-if="tr.user_id.profile_image"
                        />
                        <vs-avatar
                          color="primary"
                          class="m-0 name-avatar"
                          :text="
                            usernameList(
                              tr.user_id.firstname,
                              tr.user_id.lastname
                            )
                          "
                          size="50px"
                          v-else
                        />
                        <div class="ml-2 mt-3">
                          <b>
                            {{ tr.user_id.firstname | capitalize }}
                            {{ tr.user_id.lastname | capitalize }}
                          </b>
                        </div>
                      </div>
                    </vs-td>
                    <vs-td>{{ tr.type.value | capitalize }}</vs-td>
                    <vs-td>
                      <span>
                        {{
                          tr.start_time
                            | moment(
                              "timezone",
                              $store.state.uInfo.timeZone,
                              "DD/MM/YY"
                            )
                        }}
                      </span>
                      <span v-if="tr.start_day_option === 'H'" class="text-sm">
                        {{ tr.end_day_time }}
                      </span>
                    </vs-td>
                    <vs-td>
                      <span>
                        {{
                          tr.end_time
                            | moment(
                              "timezone",
                              $store.state.uInfo.timeZone,
                              "DD/MM/YY"
                            )
                        }}
                      </span>
                      <span v-if="tr.start_day_option === 'H'" class="text-sm">
                        {{ tr.end_day_time }}
                      </span>
                    </vs-td>
                    <vs-td width="70px">
                       <span v-if="tr.start_day_option === 'F' && tr.end_day_option === 'F' && tr.totalDays">{{ tr.totalDays > 1 ? tr.totalDays+" days" : tr.totalDays+" day" }}</span>
                       <span v-if="(tr.start_day_option === 'F' && tr.end_day_option === 'H') || (tr.start_day_option === 'H' && tr.end_day_option === 'F')">{{ tr.totalDays }} {{ tr.totalDays > 1 ?" days " :" day "}}
                       {{  convertToTime(tr.totalMinutes) }}
                       </span>
                      <span v-if="tr.start_day_option === 'H' && tr.end_day_option === 'H' && tr.totalDays == 0">{{ convertToTime(tr.totalMinutes) }}</span>
                      <span v-if="tr.start_day_option === 'H' && tr.end_day_option === 'H' && tr.totalDays != 0">{{ tr.totalDays}}{{ tr.totalDays > 1 ?" days " :" day "  }}{{  convertToTime(tr.totalMinutes) }}</span>
                    </vs-td>
                    <vs-td>
                      <!-- <p>
                        <label class="day-label" v-if="tr.start_day_option === 'H'">Partial Day:</label>
                        <span
                          :class="tr.start_day_option === 'H' ? 'text-sm' : ''"
                        >{{ tr.note | readMore }}</span>
                      </p> -->
                    </vs-td>
                    <!-- <vs-td>
                      <feather-icon
                        v-if="tr.note"
                        icon="PlusIcon"
                        class="mr-0 cursor-pointer plus-btn"
                        svg-classes="stroke-current"
                        @click.stop="viewNote(tr.note, tr.user_id.firstname,tr.user_id.lastname)"
                      ></feather-icon>
                    </vs-td> -->
                    <vs-td>
                      {{
                        tr.status == "C"
                          ? "Self Declined"
                          : tr.status == "D"
                          ? tr.decline_note
                            ? "Declined By " +
                              tr.declined_by[0].firstname +
                              " " +
                              tr.declined_by[0].lastname +
                              " for " +
                              tr.decline_note
                            : "Declined By " +
                              tr.declined_by[0].firstname +
                              " " +
                              tr.declined_by[0].lastname
                          : ""
                      }}
                    </vs-td>
                    <vs-td class="text-danger">
                      {{
                        tr.status == "C"
                          ? "Canceled"
                          : tr.status == "D"
                          ? "Declined"
                          : ""
                      }}
                    </vs-td>

                    <vs-td>
                      <span>
                        {{
                          tr.decline_time
                            | moment(
                              "timezone",
                              $store.state.uInfo.timeZone,
                              "DD/MM/YY"
                            )
                        }}
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <div id="simple-calendar-app">
        <div class="vx-card no-scroll-content p-4">
          <calendar-view
            ref="calendar"
            :displayPeriodUom="calendarView"
            :show-date="showDate"
            :events="events"
            :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
            eventBorderHeight="0px"
            eventContentHeight="1.5rem"
            @click-event="openEditEvent"
            class="theme-default"
          >
            <div slot="header" class="mb-4 header-month">
              <div class="flex justify-center">
                <!-- Month Name -->

                <!-- Current Month -->
                <div class="mr-4 self-center">
                  <div class="flex items-center">
                    <feather-icon
                      :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                      @click="updateMonth(-1)"
                      svgClasses="w-5 h-5 m-1"
                      class="cursor-pointer bg-primary text-white rounded-full"
                    />

                    <span class="mx-3 text-xl font-medium whitespace-no-wrap">
                      {{ showDate | month }}
                    </span>

                    <feather-icon
                      :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                      @click="updateMonth(1)"
                      svgClasses="w-5 h-5 m-1"
                      class="cursor-pointer bg-primary text-white rounded-full"
                    />
                  </div>
                </div>

                <div class="ml-4">
                  <template v-for="(view, index) in calendarViewTypes">
                    <vs-button
                      v-if="calendarView === view.val"
                      :key="String(view.val) + 'filled'"
                      type="filled"
                      class="p-3 md:px-8 md:py-3"
                      :class="{
                        'border-l-0 rounded-l-none': index,
                        'rounded-r-none':
                          calendarViewTypes.length !== index + 1,
                      }"
                      @click="calendarView = view.val"
                      >{{ view.label }}</vs-button
                    >
                    <vs-button
                      v-else
                      :key="String(view.val) + 'border'"
                      type="border"
                      class="p-3 md:px-8 md:py-3"
                      :class="{
                        'border-l-0 rounded-l-none': index,
                        'rounded-r-none':
                          calendarViewTypes.length !== index + 1,
                      }"
                      @click="calendarView = view.val"
                      >{{ view.label }}</vs-button
                    >
                  </template>
                </div>
              </div>

              <div class="vx-row sm:flex hidden mt-4">
                <div class="vx-col w-full flex">
                  <!-- Labels -->
                  <div class="flex flex-wrap sm:justify-start justify-center">
                    <div
                      v-for="(label, index) in eventLabels"
                      :key="index"
                      class="flex items-center mr-4 mb-2"
                    >
                      <div
                        class="h-3 w-3 inline-block rounded-full mr-2"
                        :class="'bg-' + label.color"
                      ></div>
                      <span>{{ label.text }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </calendar-view>
        </div>
      </div>
    </vx-card>
    <vs-popup
      class="holamundo note-popup text-change-popup"
      :title="'Note : ' + name"
      :active.sync="ViewNote"
      :button-close-hidden="false"
    >
      <!-- <div class="vx-col vs-lg-12 float-left form-group mb-3 w-full">
        <h5>{{ note_view }}</h5>
      </div> -->
      <div class="vx-col vs-lg-12 float-left form-group mb-3 w-full">
        <h6 class="mb-1">Edit note</h6>
        <vs-textarea v-model="note_view" v-validate="'max:200'" name="note" />
      </div>

      <div
        class="vx-col vs-lg-12 mt-0 float-right text-right form-group mb-0 w-full"
      >
        <!-- <vs-button color="success" type="filled" class="mr-0 edit-user"
          >Edit</vs-button
        > -->
        <vs-button color="success" type="filled" class="ml-2 edit-user" @click.prevent="editLeaveNote()"
          >Save</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo"
      title="Decline Leave"
      :active.sync="declineL"
      :button-close-hidden="true"
    >
      <div class="vx-row mb-2">
        <div class="vx-col md:w-2/3 w-full">
          <label for class="vs-input--label">Reason</label>
          <vs-textarea
            v-model="decline_note"
            v-validate="'max:200'"
            name="decline_note"
          />
          <span class="text-danger text-sm">
            {{ errors.first("decline_note") }}
          </span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <h3>Are you sure you want to decline this leave ?</h3>
        </div>
      </div>
      <div class="vx-col vs-lg-12 mt-2 float-left form-group mb-2 w-full">
        <vs-button
          color="success"
          type="filled"
          class="mr-2 edit-user float-left"
          @click.stop="declineLeave()"
          >Decline</vs-button
        >
        <vs-button
          color="warning"
          type="filled"
          class="mr-2 edit-user float-left"
          @click.stop="
            (declineL = false), (decline_id = null), (decline_note = '')
          "
          >Cancel</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo"
      title="Confirm"
      :active.sync="cancelL"
      :button-close-hidden="true"
    >
      <div class="vx-col vs-lg-12 float-left form-group mb-2 w-full">
        <h5>Are you sure you want to cancel this leave?</h5>
      </div>
      <div class="vx-col vs-lg-12 mt-2 float-left form-group mb-2 w-full">
        <vs-button
          color="success"
          type="filled"
          class="mr-2 edit-user float-left"
          @click.stop="cancelLeave()"
          >Cancel Leave</vs-button
        >
        <vs-button
          color="warning"
          type="filled"
          class="mr-2 edit-user float-left"
          @click.stop="(cancelL = false), (cancel_id = null)"
          >Cancel</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo"
      title="Confirm"
      :active.sync="approveL"
      :button-close-hidden="true"
    >
      <div class="vx-col vs-lg-12 float-left form-group mb-2 w-full">
        <h5>Are you sure you want to approve this leave?</h5>
      </div>
      <div class="vx-col vs-lg-12 mt-2 float-left form-group mb-2 w-full">
        <vs-button
          color="success"
          type="filled"
          class="mr-2 edit-user float-left"
          @click.stop="approveUserLeave()"
          >Approve</vs-button
        >
        <vs-button
          color="warning"
          type="filled"
          class="mr-2 edit-user float-left"
          @click.stop="(approveL = false), (approve_id = null)"
          >Cancel</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo"
      title="Leave Details"
      :active.sync="activePromptEditEvent"
      :button-close-hidden="true"
    >
      <div class="overflow-auto mb-5">
        <table v-if="viewLeaveData">
          <tr>
            <th>Name</th>
            <td>
              <div
                class="relative inline-flex float-left"
                v-if="
                  viewLeaveData.profile_image ||
                  (viewLeaveData.firstname && viewLeaveData.lastname)
                "
              >
                <vs-avatar
                  class="m-0"
                  :src="viewLeaveData.profile_image"
                  size="50px"
                  v-if="viewLeaveData.profile_image"
                />
                <vs-avatar
                  color="primary"
                  class="m-0 name-avatar"
                  :text="
                    usernameList(
                      viewLeaveData.firstname,
                      viewLeaveData.lastname
                    )
                  "
                  size="50px"
                  v-else
                />
                <div class="ml-2 mt-3">
                  <b>
                    {{ viewLeaveData.firstname | capitalize }}
                    {{ viewLeaveData.lastname | capitalize }}
                  </b>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>Leave Type</th>
            <td>{{ viewLeaveData.leaveType }}</td>
          </tr>

          <tr>
            <th>Start</th>
            <td>
              {{
                viewLeaveData.leaveStartTime ? viewLeaveData.leaveStartTime : ""
              }}
            </td>
          </tr>

          <tr>
            <th>End</th>
            <td>
              {{ viewLeaveData.leaveEndTime ? viewLeaveData.leaveEndTime : "" }}
            </td>
          </tr>
          <tr>
            <th>Note</th>
            <td>{{ viewLeaveData.note }}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>
              <span v-if="viewLeaveData.leaveStatus === 'P'">Pending</span>
              <span v-else-if="viewLeaveData.leaveStatus === 'A'"
                >Approved</span
              >
              <span v-else-if="viewLeaveData.leaveStatus === 'D'"
                >Declined</span
              >
              <span v-else-if="viewLeaveData.leaveStatus === 'C'">Cancel</span>
              <span v-else></span>
            </td>
          </tr>
        </table>
      </div>
      <vs-button
        color="warning"
        type="filled"
        class="mr-2 edit-user float-right"
        @click.stop="(viewLeaveData = {}), (activePromptEditEvent = false)"
        >Cancel</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
require("vue-simple-calendar/static/css/default.css");
import Datepicker from "vuejs-datepicker";
import moment from "moment";
const dict = {
  custom: {
    is_applied_by_other: {
      required: "Please select personal/staff leave",
    },
    office_id_hr: {
      required: "Please select office",
    },
    department_id: {
      required: "Please select Department",
    },
    user_id: {
      required: "Please select User",
    },
    type: {
      required: "Please select leave type",
    },
    note: {
      required: "Please enter description",
      max: "Description should not be greater than 200 characters",
    },
    decline_note: {
      max: "Reason should not be greater than 200 characters",
    },
    start_date: {
      required: "Please select start date",
    },
    start_time: {
      required: "Please select start time",
    },
    start_day_option: {
      required: "Please select start day",
    },
    end_date: {
      required: "Please select end date",
    },
    end_time: {
      required: "Please select end time",
    },
    end_day_option: {
      required: "Please select end day",
    },
  },
};
Validator.localize("en", dict);
export default {
  data() {
    return {
      holidayList:null,
      officeStartTime:null,
      officeEndTime:null,
      workingDaysArr:[],
      workingDays:0,
      office:"",
      department:"",
      search:"",
      disableOption: false,
      eventLabels: [
        {
          text: "Approved",
          value: "approved",
          color: "success",
        },
        {
          text: "Pending",
          value: "pending",
          color: "warning",
        },
        {
          text: "Declined/Cancel",
          value: "declined",
          color: "danger",
        },
      ],
      declineL: false,
      approveL: false,
      cancelL: false,
      ViewNote: false,
      note_view: null,
      note_leave_id: null,
      name: null,
      cancel_id: null,
      decline_note: "",
      leaves: [],
      pending: [],
      approved: [],
      declined: [],
      offices: [],
      officesAll: [],
      departments: [],
      departmentsAll: [],
      approveleave: false,
      department_id: null,
      is_applied_by_other: null,
      users: [],
      usersAll: [],
      user_id: null,
      office_id_hr: null,
      leaveAddEdit: false,
      leavetypes: [],
      title: "",
      type: null,
      start_day_option: "F",
      end_day_option: "Full",
      start_time: null,
      start_date: null,
      end_time: null,
      end_date: null,
      events: [],
      note: "",
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        dateFormat: "G:i K",
      },
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null,
        dateFormat: "d-m-Y",
      },
      configTodateTimePicker: {
        minDate: new Date(),
        dateFormat: "d-m-Y",
      },
      decline_id: null,
      approve_id: null,

      //calender test data
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      titleC: "",
      startDate: "",
      endDate: "",
      labelLocal: "none",
      url: "",
      calendarView: "month",

      activePromptAddEvent: false,
      activePromptEditEvent: false,
      viewLeaveData: {},
      calendarViewTypes: [
        {
          label: "Month",
          val: "month",
        },
      ],
      totalDays: 0,
      totalDaystopass:0,
      totalMinutespass:0,
    };
  },

  created() {},
  mounted() {
    this.getLeaveType();
    this.getLeaveData();
    this.getOffice();
    //this.getDept();
    this.getUsers();
    this.getDateTimeData();
  },
  filters: {
    readMore(str) {
      if (!str) return "";
      return str.substr(0, 20) + " ... ";
    },
  },
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
  },
  computed: {
    simpleCalendarEvents() {
      return this.$store.state.calendar.events;
    },
    validForm() {
      return (
        this.title != "" &&
        this.startDate != "" &&
        this.endDate != "" &&
        Date.parse(this.endDate) - Date.parse(this.startDate) >= 0 &&
        !this.errors.has("event-url")
      );
    },
    disabledDatesTo() {
      return {
        to: new Date(this.startDate),
      };
    },
    disabledDatesFrom() {
      return {
        from: new Date(this.endDate),
      };
    },
    calendarLabels() {
      return this.$store.state.calendar.eventLabels;
    },
    labelColor() {
      return (label) => {
        if (label == "approved") {
          return "bg-success";
        } else if (label == "pending") return "warning";
        if (label == "decline") return "danger";
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  watch: {
    start_day_option(val){
      if(val){
        this.start_time = null;
        this.calculateDays();
      }
    },
    end_day_option(val){
      if(val){
        this.end_time = null;
        this.calculateDays();
      }
    }
  },

  methods: {
     onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
      this.calculateDays();
    },
    calculateHours(start, startDate, end, endDate) {
      var d1 = moment.tz(startDate, this.$store.state.uInfo.timeZone).format('DD/MM/YYYY').toString();
      var d2 = moment.tz(endDate, this.$store.state.uInfo.timeZone).format('DD/MM/YYYY').toString();
      // var d1 = moment(startDate)
      //   .zone(this.$store.state.uInfo.timeZone)
      //   .format("MM/DD/YYYY")
      //   .toString();
      // var d2 = moment(endDate)
      //   .zone(this.$store.state.uInfo.timeZone)
      //   .format("MM/DD/YYYY")
      //   .toString();
        var timeStart = new Date(`${d1} ${start}`).getTime();
        var timeEnd = new Date(`${d2} ${end}`).getTime();   
      var diff = (timeEnd - timeStart) / 60000; //dividing by seconds and milliseconds
      var minutes = diff % 60;
      var hours = (diff - minutes) / 60;
      // hours = hours < 10 ? " " + hours.toString() : hours;
      // minutes = minutes < 10 ? "" + minutes.toString() : minutes;
      if (hours == 1) {
        return hours + " hour";
      } else if (hours < 24) {
        return hours + "." + minutes + "hours";
      } else return null;
    },
    getDaysBetweenDates(startDate, endDate) {
        var now = moment(startDate).clone(), dates = [];
         while (now.isSameOrBefore(moment(endDate))) {
            dates.push(now.format('DD/MM/YYYY'));
            now.add(1, 'days');
        }
        return dates;
    },
    convertToTime(totalMinutes) {
      if (totalMinutes) {
        const addZero = d => (d > 9 ? d.toString() : "0" + d.toString());
        let hours = addZero(Math.floor(totalMinutes / 60));
        let minutes = addZero(totalMinutes % 60);
        let str = hours != "01"?" hrs ":" hr ";
        return hours + str + minutes+" min";
      } else {
        return "00:00";
      }
    },
    calculateDays() {
      if (this.start_date && this.end_date) {
        var s = this.start_date.split("-");
        var e = this.end_date.split("-");

        let startDate = new Date(`${s[1]}-${s[0]}-${s[2]}`).getTime();
        var endDate = new Date(`${e[1]}-${e[0]}-${e[2]}`).getTime();
       
        let totalLeaveDays = 0;
          const stDt = moment(this.start_date,'DD-MM-YYYY').format('YYYY-MM-DD');
          const endDt = moment(this.end_date,'DD-MM-YYYY').format('YYYY-MM-DD');

          var dateList = this.getDaysBetweenDates(stDt, endDt);
          dateList.forEach(element => {
              if(this.workingDaysArr.includes(moment(element,'DD/MM/YYYY').format('dddd'))){
                if(!this.holidayList.find( ({ date }) => moment(date).format('DD/MM/YYYY') === element)){
                  totalLeaveDays++;
                }
              }
          });
          if(this.start_day_option == 'H' && this.end_day_option == 'Half' && startDate != endDate && this.start_time && this.end_time){
              totalLeaveDays = totalLeaveDays -2;
              let officeEnd = this.officeEndTime;
              let startTime = this.start_time;
             
              let newSt = moment(this.start_date+" "+startTime,"DD/MM/YYYY HH:mm A").valueOf();
              let newos = moment(this.start_date+" "+officeEnd,"DD/MM/YYYY HH:mm A").valueOf();
              let ofms = newos - newSt;
              let officestart = this.officeStartTime;
              let endTime = this.end_time;
              let newoe = moment(this.start_date+" "+officestart,"DD/MM/YYYY HH:mm A").valueOf();
              let newEnd = moment(this.start_date+" "+endTime,"DD/MM/YYYY HH:mm A").valueOf();
              let ofme = newEnd - newoe;

              let totTime = this.convertToTime((ofms+ofme)/(1000*60));
              this.totalDaystopass = totalLeaveDays;
              let wordDay = totalLeaveDays >1?" Days ":" Day ";
               totalLeaveDays = (totalLeaveDays != 0)?totalLeaveDays+wordDay+totTime:totTime;
              this.totalMinutespass = (ofms+ofme)/(1000*60);
          } else if(this.start_day_option == 'H' && this.end_day_option == 'Half' && startDate == endDate && this.start_time && this.end_time){
            let startTime = this.start_time;
            let newSt = moment(this.start_date+" "+startTime,"DD/MM/YYYY HH:mm A").valueOf();
            let endTime = this.end_time;
            let newEnd = moment(this.end_date+" "+endTime,"DD/MM/YYYY HH:mm A").valueOf();
            let ofme = newEnd - newSt;
            let totTime = this.convertToTime((ofme)/(1000*60));
            this.totalDaystopass = 0;
            this.totalMinutespass = (ofme)/(1000*60);
            totalLeaveDays = totTime;
          } else if(this.start_day_option == 'H' && this.start_time){
              totalLeaveDays = totalLeaveDays -1;
              let officeEnd = this.officeEndTime;
              let startTime = this.start_time;
              let newSt = moment(this.start_date+" "+startTime,"DD/MM/YYYY HH:mm A").valueOf();
              let newos = moment(this.start_date+" "+officeEnd,"DD/MM/YYYY HH:mm A").valueOf();
              let ofms = newos - newSt;
              let totTime = this.convertToTime((ofms)/(1000*60));
                this.totalDaystopass = totalLeaveDays;
            this.totalMinutespass = (ofms)/(1000*60);
              let wordDay = totalLeaveDays >1?" Days ":" Day ";
               totalLeaveDays = (totalLeaveDays != 0)?totalLeaveDays+wordDay+totTime:totTime;
          } else if(this.end_day_option == 'Half' && this.end_time){
              totalLeaveDays = totalLeaveDays -1;
             let officestart = this.officeStartTime;
              let endTime = this.end_time;
              let newoe = moment(this.start_date+" "+officestart,"DD/MM/YYYY HH:mm A").valueOf();
              let newEnd = moment(this.start_date+" "+endTime,"DD/MM/YYYY HH:mm A").valueOf();
              let ofme = newEnd - newoe;
              let totTime = this.convertToTime((ofme)/(1000*60));
              this.totalDaystopass = totalLeaveDays;
              this.totalMinutespass = (ofme)/(1000*60);
               let wordDay = totalLeaveDays >1?" Days ":" Day ";
              totalLeaveDays = (totalLeaveDays != 0)?totalLeaveDays+wordDay+totTime:totTime;
          } else {
            this.totalDaystopass = totalLeaveDays;
            this.totalMinutespass = 0;
            let wordDay = totalLeaveDays >1?" Days ":" Day ";
            totalLeaveDays = totalLeaveDays+wordDay;
          }
        this.totalDays = totalLeaveDays;
      } else {
        this.totalDays = 0;
      }
    },
    openEditEvent(event) {
      this.leaves.forEach((element) => {
        if (element._id == event.id) {
          this.viewLeaveData.firstname = element.user_id.firstname;
          this.viewLeaveData.lastname = element.user_id.lastname;
          this.viewLeaveData.profile_image = element.user_id.profile_image;
          this.viewLeaveData.leaveType = element.type.value;
          this.viewLeaveData.note = element.note;
          this.viewLeaveData.appliedDate = moment.tz(element.createdAt, this.$store.state.uInfo.timeZone).format('DD/MM/YYYY h:mm A');
          this.viewLeaveData.leaveStartTime = moment.tz(element.start_time, this.$store.state.uInfo.timeZone).format('DD/MM/YYYY h:mm A');
          this.viewLeaveData.leaveEndTime = moment.tz(element.end_time, this.$store.state.uInfo.timeZone).format('DD/MM/YYYY h:mm A');
         
          this.viewLeaveData.leaveStatus = element.status;
        }
      });
      this.activePromptEditEvent = true;
    },
    updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
    },
    usernameList(firstname, lastname) {
      let first = firstname.trim().charAt(0);
      let last = lastname.trim().charAt(0);
      let name = first.concat(last);
      return name.toUpperCase();
    },
    getLeaveData() {
      this.$vs.loading({
        color: "primary",
      });
      let url = "leave?";
      url += "&office_id="+this.office;
      url += "&department="+ this.department;
      url += "&search="+ this.search;

      this.axios
        .get(url)
        .then((response) => {
          let data = response.data.data;
          this.pending = [];
          this.approved = [];
          this.declined = [];
          this.events = [];
          this.leaves = data;

          this.leaves.forEach((element) => {
            if (element.status == "P") {
              this.pending.push(element);
            } else if (element.status == "A") {
              this.approved.push(element);
            } else {
              this.declined.push(element);
            }
            this.events.push({
              id: element._id,
              title: element.user_id.firstname + " " + element.user_id.lastname,
              startDate: moment.tz(element.start_time, this.$store.state.uInfo.timeZone).format('YYYY-MM-DD h:mm A'),
              endDate: moment.tz(element.end_time, this.$store.state.uInfo.timeZone).format('YYYY-MM-DD h:mm A'),
              url: "",
              classes:
                element.status == "P"
                  ? "event-warning"
                  : element.status == "A"
                  ? "event-success"
                  : "event-danger",
              label:
                element.status == "P"
                  ? "pending"
                  : element.status == "A"
                  ? "approved"
                  : "declined",
            });
          });
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    getLeaveType() {
      this.$vs.loading({
        color: "primary",
      });

      let url = "leaveType";
      this.axios
        .get(url)
        .then((response) => {
          let data = response.data.data;
          this.leavetypes = data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    decline(id) {
      this.decline_id = id;
      this.declineL = true;
    },
    declineLeave() {
      let input = {
        leave_id: this.decline_id,
        decline_note: this.decline_note,
      };
      this.axios
        .put("declineLeave", input)
        .then(() => {
          this.button_loader(false, "#leavetype-addupdate");
          let text = "Leave declined successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right",
          });
          this.declineL = false;
          this.decline_id = null;
          this.decline_note = "";
          this.getLeaveData();
        })
        .catch((e) => {
          this.showError(e, "#leavetype-addupdate");
        });
    },
    getOffice() {
      this.$vs.loading({
        color: "primary",
      });

      let url = "office/getAll";
      this.axios
        .get(url)
        .then((response) => {
          let data = response.data.data;
          this.officesAll = data;
          this.offices = data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    getDept() {
      this.$vs.loading({
        color: "primary",
      });
      let url = "dept/getAll?office_id="+this.office;
      this.axios
        .get(url)
        .then((response) => {
          let data = response.data.data;
          this.departments = data;
          this.departmentsAll = data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.showError(e);
        });
    },    
    changeUser() {
      let selectedUser = this.usersAll.filter((i) => i.id === this.user_id)[0];
      this.office_id_hr = selectedUser.office;
      this.department_id = selectedUser.department;
    },

    changeDept() {
      let selectedDepartment = this.departmentsAll.filter(
        (i) => i.id === this.department_id
      )[0];
      this.office_id_hr = selectedDepartment.office_id.id;
      this.users = this.usersAll.filter(
        (i) => i.department === this.department_id
      );
    },

    async changeOffice() {
      let office_id = this.office_id_hr;
      this.departments = this.departmentsAll.filter(
        (i) => i.office_id.id === office_id
      );
      this.users = this.usersAll.filter((i) => i.office === office_id);
    },
    getUsers() {
      this.$vs.loading({
        color: "primary",
      });

      let url =
        "user/listUsers?department_=" +
        this.department_id +
        "&office_=" +
        this.office_id_hr;
      this.axios
        .get(url)
        .then((response) => {
          let data = response.data.data;
          this.users = data;
          this.usersAll = data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    addLeave() {
      this.$validator.validateAll("leave-form").then((result) => {
        if (result) {
              this.button_loader(true, "#leavetype-addupdate");
          let input = {
            type: this.type,
            start_day_option: this.start_day_option,
            end_day_option: this.end_day_option =='Full'?'F':'H',
            is_applied_by_other: this.is_applied_by_other,
            user_id:
              this.is_applied_by_other == true
                ? this.user_id
                : this.$store.state.uInfo.id,
            status: this.approveleave == true ? "A" : "P",
            start_time: this.start_date,
            end_time: this.end_date,
            note: this.note,
            title: this.title,
            start_day_time: this.start_time ? this.start_time : "",
            end_day_time: this.end_time ? this.end_time : "",
            "totalDays":this.totalDaystopass,
            "totalMinutes" : this.totalMinutespass,
            "office" : this.office_id_hr?this.office_id_hr:this.$store.state.uInfo.office_id?this.$store.state.uInfo.office_id:null,
            "deapartment" : this.department_id?this.department_id:null,
          };
          this.axios
            .post("leave", input)
            .then(() => {
              this.button_loader(false, "#leavetype-addupdate"); 
              let text = "Leave added successfully!!!";
              this.$vs.notify({
                text: text,
                color: "success",
                position: "top-right",
              });
              this.cancelAdd();
              this.getLeaveData();
            })
            .catch((e) => {
              this.showError(e, "#leavetype-addupdate");
            });
        }
      });
    },
    confirmApproveLeave(id) {
      this.approve_id = id;
      this.approveL = true;
    },
    viewNote(note, leave_id, first_name, last_name) {
      this.note_view = note;
      this.note_leave_id = leave_id;
      this.name = first_name + " " + last_name;
      this.ViewNote = true;
    },
    approveUserLeave() {
      let input = {
        leave_id: this.approve_id,
      };
      this.axios
        .put("approveLeave", input)
        .then(() => {
          this.button_loader(false, "#leavetype-addupdate");
          let text = "Leave approved successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right",
          });
          this.approveL = false;
          this.approve_id = null;
          this.getLeaveData();
        })
        .catch((e) => {
          this.showError(e, "#leavetype-addupdate");
        });
    },
    cancelConfirmation(id) {
      this.cancel_id = id;
      this.cancelL = true;
    },
    cancelLeave() {
      let input = {
        leave_id: this.cancel_id,
      };
      this.axios
        .put("leave", input)
        .then(() => {
          this.button_loader(false, "#leavetype-addupdate");
          let text = "Leave canceled successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right",
          });
          (this.cancel_id = null), (this.cancelL = false);
          this.getLeaveData();
        })
        .catch((e) => {
          this.showError(e, "#leavetype-addupdate");
        });
    },
    cancelAdd() {
      this.type = null;
      this.title = "";
      this.note = "";
      this.office_id_hr = null;
      this.department_id = null;
      this.totalDays = null;
      (this.departments = []), (this.user_id = null);
      (this.users = []), (this.start_date = null);
      this.start_time = null;
      this.start_day_option = "F";
      this.end_date = null;
      this.end_time = null;
      this.end_day_option = "Full";
      this.is_applied_by_other = null;
      this.errors.clear();
      this.leaveAddEdit = false;
      //location.reload();
    },
    // Edit Leave Note
    editLeaveNote(){
      if (!this.note_view) {
        this.$vs.notify({
            text: "Please enter leave note.",
            color: "danger",
            position: "top-right"
        });
        return false;
      }
      this.$vs.loading({ color: "primary"});
      let url = "leave/note";
      let data = {
          l_id : this.note_leave_id,
          note : this.note_view
      };
      this.axios
        .put(url,data)
        .then((response) => {
          if (response.data) {
            this.ViewNote = false;
            this.note_leave_id = null;
            this.note_view = null;
            this.getLeaveData();
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    getDateTimeData() {
      this.$vs.loading({ color: "primary" });

      let url = "oinfo/getInfo";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          let startDay = data.week_start_day;
          let endDay = data.week_end_day;
          let days = [{day:1,name:'Mo'},{day:2,name:'Tu'},{day:3,name:'We'},{day:4,name:'Th'},{day:5,name:'Fr'},{day:6,name:'Sa'},{day:7,name:'Su'}];
          let start = days.find( ({ name }) => name === startDay );
          let end = days.find( ({ name }) => name === endDay );
          let workingDays = (end.day - start.day)+1;
          this.workingDays = workingDays;
          let daysWorking = [{day:0,name:'Su',fullname:"Sunday"},{day:1,name:'Mo',fullname:"Monday"},{day:2,name:'Tu',fullname:"Tuesday"},{day:3,name:'We',fullname:"Wednesday"},{day:4,name:'Th',fullname:'Thursday'},{day:5,name:'Fr',fullname:'Friday'},{day:6,name:'Sa',fullname:"Saturday"}];
          let startworkingday = daysWorking.find( ({ name }) => name === startDay );
          let endworkingday = daysWorking.find( ({ name }) => name === endDay );
          let startArr = [];
          let endArr = [];
          // for (let index = 0; index < daysWorking.length; index++) {
          //   if(index >= startworkingday.day){
          //     startArr.push(daysWorking[index].fullname);
          //   }
          //   if(index <= endworkingday.day){
          //     endArr.push(daysWorking[index].fullname);
          //   }
          // }
          for (let index = 0; index < daysWorking.length; index++) {
            if(startworkingday.day  > endworkingday.day) {
                if(index >= startworkingday.day){
                 startArr.push(daysWorking[index].fullname);
                }
                if(index <= endworkingday.day){
                  endArr.push(daysWorking[index].fullname);
                }
              }
            else {
               if(startworkingday.day <=index && endworkingday.day >=index){
                startArr.push(daysWorking[index].fullname);
              } 
            }
          }
          this.workingDaysArr = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
          // this.workingDaysArr =  startArr.concat(endArr);
          // console.log(this.workingDaysArr);
          this.officeStartTime = data.working_time_from;
          this.officeEndTime = data.working_time_to;
          this.holidayList = data.holidays;
        })
        .catch(e => {
          this.showError(e);
        });
    },
  },
};
</script>

<style scoped>
.note-popup .vs-popup--title h3 {
  text-transform: capitalize;
}
.name {
  align-items: center;
}
.leave-img img {
  border-radius: 50% !important;
}
.vx-card .vx-card__collapsible-content img {
  display: unset !important;
}
.plus-btn {
  width: 15px;
  height: 15px;
}
.day-label {
  font-size: 14px !important;
  font-weight: normal !important;
}
</style>
